// API
export const WIZARD_SUCCESS = 'WIZARD_SUCCESS';

// State update
export const WIZARD_UPDATE = 'WIZARD_UPDATE';
